import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Valida que el valor del campo no sea menor al valor de un campo de referencia (como creditLimit).
 * @param creditLimitField El nombre del campo del que se obtiene el límite mínimo.
 */
export function minCreditValidator(creditLimitField: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.parent) return null;

    const creditLimit = control.parent.get(creditLimitField)?.value;
    const rawValue = control.value;

    if (creditLimit == null || rawValue == null) return null;

    const numericValue = Number(String(rawValue).replace(/,/g, ''));

    if (numericValue < creditLimit) {
      return { belowMinLimit: true };
    }

    return null;
  };
}
